export const getStrategySamplePortfolioId = `
query getStrategySamplePortfolio($strategyId: String) {
  getStrategySamplePortfolio(input: {strategyId: $strategyId}) {
    id
  }
}
`
